import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Radio } from '@dev/ee-components';
import { TimingOptionEnum } from '@dev/ee-api/ee-api-models';
import styled from 'styled-components';

import { TimingOptionProps } from '@/components/CampaignCreator/SettingsAndTracking/SettingsAndTrackingInterface';
import { ModifyCampaignMap } from '@/store/campaignCreator/actions';
import { useCampaignScreensPathsChecker } from '../../../../../../hooks/useCampaignScreensPathsChecker';

const SendTimeRadiosWrapper = styled.div`
    margin-top: 16px;
    margin-left: 60px;
`;

export const TimingOptions = (props: TimingOptionProps): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isDetailsScreen } = useCampaignScreensPathsChecker();
    const { timing, setTiming } = props;

    const changeRadio = (ev): void => {
        setTiming(ev.target.value);
        const modifyMap = new Map<string, any>();
        modifyMap.set('Options.TimingOption', ev.target.value);
        dispatch(ModifyCampaignMap(modifyMap));
    };

    return (
        <SendTimeRadiosWrapper>
            <Radio
                name="sendTime-radio-opt"
                id="sendTime-radio-opt"
                value={timing}
                onChange={changeRadio}
                labelPlacement="end"
                radioPlacement="start"
                radios={[
                    {
                        id: 'mostEngagedContacts',
                        label: t('sendtothemostengagedcontacts'),
                        value: TimingOptionEnum.EngagedContactFirst,
                        disabled: isDetailsScreen,
                        description: t('sendtothemostengagedcontacts_desc'),
                    },
                    {
                        id: 'optimalOpenTime',
                        label: t('sendinoptimaltime'),
                        value: TimingOptionEnum.OptimalOpenTime,
                        disabled: isDetailsScreen,
                        description: t('sendinoptimaltime_desc'),
                    },
                ]}
            />
        </SendTimeRadiosWrapper>
    );
};
